export const config = {
  title: "Hall Carpet Cleaning Service",
  meta: {
    description:
      "Hall Carpet Cleaning Service provides professional carpet cleaning and floor care solutions in Temple, GA and surrounding areas.",
    keywords: [
      "Carpet Cleaning Temple GA",
      "Floor Care Services",
      "Upholstery Cleaning Temple",
      "Rug Cleaning Georgia",
      "Hall Carpet Cleaning Service",
    ],
    author: "Hall Carpet Cleaning Service",
    canonicalUrl: "https://hallcarpetcleaningservice.com/",
  },
  sections: {
    header: {
      businessName: "Hall Carpet Cleaning Service",
    },
    sectionB: {
      heroTitle: "Your Floor, Our Priority",
      heroSubtitle: "Exceptional Carpet and Floor Cleaning in Georgia",
      learnAboutText: "View Our Services",
      phoneNumber: "4709104751",
      phoneLabel: "(470) 910-4751",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1209235404/photo/close-up-of-steam-cleaner-cleaning-very-dirty-carpet.jpg?s=612x612&w=0&k=20&c=HZGi-TJYdibkJ0FdLjQKD6JpuvJApQipMvRAWpGEC0A=", // Replace with a valid image if needed
      cardData: [
        {
          title: "Residential Carpet Cleaning",
          description:
            "Restore your home’s comfort and cleanliness with our professional carpet care.",
        },
        {
          title: "Commercial Floor Services",
          description:
            "Reliable and efficient cleaning solutions tailored for businesses and offices.",
        },
        {
          title: "Upholstery & Rug Care",
          description:
            "Gentle yet thorough cleaning for your upholstered furniture and area rugs.",
        },
      ],
      description:
        "Hall Carpet Cleaning Service brings years of experience and unmatched dedication to floor and carpet cleaning in Temple, GA. Whether for home or business, expect outstanding results every time.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Professional cleaning solutions designed to meet the needs of both homes and businesses in Temple, GA and surrounding areas.",
      cards: [
        {
          title: "Janitorial Services",
          description:
            "Maintain a spotless and sanitary workspace with thorough janitorial solutions for offices and commercial spaces.",
          imageSrc:
            "https://media.istockphoto.com/id/2189771873/photo/young-asian-cleaning-woman-uses-a-cloth-to-wipe-clean-a-computer-using-cleaning-solution-in.jpg?s=612x612&w=0&k=20&c=HmNQRlxpSLb9J4xZhcQ7urgpc7mxaiROP_wh1rO6V_A=", // Replace with your actual image
          imageAlt: "Janitorial Services",
        },
        {
          title: "Carpet Cleaning",
          description:
            "Deep clean and refresh carpets with effective stain and odor removal using eco-friendly techniques.",
          imageSrc:
            "https://media.istockphoto.com/id/832990938/photo/person-cleaning-carpet-with-vacuum-cleaner.jpg?s=612x612&w=0&k=20&c=M2PuEJzJ3xOCTlgl-UwkXizizV1946ghxWBD2VH_Fb0=",
          imageAlt: "Carpet Cleaning",
        },
        {
          title: "Residential Cleaning",
          description:
            "Enjoy a pristine home with personalized cleaning plans tailored to your lifestyle and preferences.",
          imageSrc:
            "https://media.istockphoto.com/id/1312450007/photo/women-cleaning-windows-in-apartment.jpg?s=612x612&w=0&k=20&c=ZNsCph1gN03vlV7jVxHoxN2zTgiFAkKKhFXYDA7_52Q=", // Replace with your actual image
          imageAlt: "Residential Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Pet Odor Removal",
        "Stain Protection",
        "Steam Cleaning",
        "Eco-Friendly Products",
        "Flexible Scheduling",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://speedy.uenicdn.com/e0504836-5540-4afe-96de-0920a84da89f/c880_a/image/upload/v1747938964/business/42254f7b-69f6-4965-bcfe-ef63bcdd6538.jpg",
        alt: "Owner Eddie Hall",
      },
      aboutText: [
        "Founded and operated by Eddie Hall, Hall Carpet Cleaning Service has served the Temple, GA community with honesty and quality.",
        "Every service is carried out with attention to detail, friendly customer service, and a commitment to cleanliness and satisfaction.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Hall Carpet Cleaning Logo",
      businessName: "Hall Carpet Cleaning Service",
      contact: {
        phone: "4709104751",
        phoneLabel: "(470) 910-4751",
        email: "hall.eddie60@yahoo.com",
        website: "https://hallcarpetcleaningservice.com/",
        address: "34 Clint Ct, Temple, GA 30179",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "34 Clint Ct, Temple, GA 30179",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=34+Clint+Ct,+Temple,+GA+30179&output=embed",
    },
  },
};

export default config;
